import FormInvite from './FormInvite';

export default FormInvite;



// WEBPACK FOOTER //
// ./src/components/Login/FormInvite/index.js